export default "__VITE_ASSET__8uTtVOR8__"